import { PenTool, Moon, Fingerprint, CreditCard } from "lucide-react";
import { Reveal } from "./Shared";

const ITEMS = [
  { icon: PenTool, main: "100% Human Vector Artists", sub: "Zero AI Generation", test: "trust-badge-humans" },
  { icon: Moon, main: "Overnight Timezone Studio", sub: "5PM to 8AM EST", test: "trust-badge-overnight" },
  { icon: Fingerprint, main: "Exclusive Designs Per Client", sub: "Never Resold", test: "trust-badge-exclusive" },
  { icon: CreditCard, main: "Secure Enterprise Payments", sub: "Cancel Anytime", test: "trust-badge-payments" },
];

export default function TrustBar() {
  return (
    <section
      data-testid="trust-bar"
      aria-label="Grapho guarantees"
      className="relative border-y border-amber-400/15 bg-[#0A1020]/70 px-6 py-6 backdrop-blur-sm"
    >
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map((item, i) => (
          <Reveal key={item.test} delay={i * 0.08}>
            <div data-testid={item.test} className="flex items-center gap-3">
              <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-amber-400/30 bg-amber-400/10">
                <item.icon className="h-5 w-5 text-amber-300" />
              </span>
              <p className="min-w-0 text-sm leading-snug">
                <span className="block font-bold text-white">{item.main}</span>
                <span className="mt-0.5 block font-mono text-[10px] uppercase tracking-wider text-slate-500">
                  {item.sub}
                </span>
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}